import React, { useEffect, useState, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import appProp from "../server";
import { EthersContext, contractInfo } from "../ethers/EthersProvider";
import "../css/base.css";
import "../css/rankings.css";
import title_img from "../img/title.png";
import ico_crown from "../img/icon-crown.svg";
import icon_game_console from "../img/icon-game-console.png";

const postData = async (url = "", data = {}) => {
  return fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data)
  }).then(response => response.json());
};

const StartDate = "2020-01-01";
const EndDate = "2030-01-01";

const Ranking = props => {
  const {
    provider,
    signer,
    account,
    setAccount,
    networkId,
    setNetworkId,
    verified,
    setVerified,
    initialized,
    setWalletConnect
  } = useContext(EthersContext);
  /* 
  board
    Address: "0xaaaa"
    Datestring: ""
    Point: "1"
  */
  const [board, setBoard] = useState([]);
  const [myrecord, setMyRecord] = useState(null);
  const [before_rec, setBeforeRecord] = useState(null);
  const [after_rec, setAfterRecord] = useState(null);
  const [teampoints, setTeamPoints] = useState([]);

  const ranking_limit = 20;

  const [isPlayPaused, setPlayPause] = React.useState(false);
  useEffect(() => {
    setPauseGame("2022-04-21 00:00:00", "2022-04-22 00:00:00");
    // setPauseGame("2022-04-20 21:00:00", "2022-04-22 00:00:00");
  }, []);

  useEffect(() => {
    console.log("account =>", account);
    if (account !== null && account.length > 0) {
      startApp();
    }
  }, [account]);

  const startApp = async () => {
    try {
      // Boards
      let res_boards = await postData(appProp.boardURL, {
        limit: ranking_limit
      });
      if (res_boards !== null) {
        // console.log("rankingboard res =>", res_boards);
        res_boards.sort(function (a, b) {
          return parseInt(a.Ranking) - parseInt(b.Ranking);
        });
        // console.log("res_boards =>", res_boards);
        setBoard(res_boards);
      }

      // My Ranking
      let myres = await postData(appProp.myrecordURL, {
        address: account
      });
      if (myres !== null) {
        // console.log("rankingboard myres =>", myres);
        setMyRecord(myres);
        if (myres.Ranking > 1) {
          const base_idx = myres.Ranking - 1;
          setBeforeRecord(res_boards[base_idx - 1]);

          if (myres.Ranking < res_boards.length) {
            setAfterRecord(res_boards[base_idx + 1]);
          }
        }
      }

      // Team Points
      let tempPoints = await postData(appProp.pointbyteamURL, {});
      if (
        tempPoints !== null &&
        tempPoints != undefined &&
        tempPoints.length > 0
      ) {
        setTeamPoints(tempPoints);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const shortAddres = _address => {
    let rtVal = "";
    if (_address != undefined && _address.length > 0) {
      rtVal =
        _address.substring(0, 6) +
        "      ...      " +
        _address.substring(_address.length - 4, _address.length);
    }
    return rtVal;
  };

  const shortId = _id => {
    let rtVal = "";
    if (_id != undefined) {
      if (_id.length > 0) {
        let tmp_id = _id.substring(0, _id.indexOf("#"));
        if (tmp_id.length == 0) {
          rtVal = _id;
        } else {
          if (getWindowWidth() < 900) {
            if (tmp_id.length > 13) {
              rtVal =
                tmp_id.substring(0, 6) +
                "      ...      " +
                tmp_id.substring(tmp_id.length - 5, tmp_id.length);
            } else {
              rtVal = tmp_id;
            }
          } else {
            rtVal = tmp_id;
          }
        }
      }
    }
    return rtVal;
  };

  const shortTeamName = _teamname => {
    let rtVal = "";
    if (_teamname !== null && _teamname !== undefined && _teamname.length > 0) {
      rtVal = _teamname.substring(0, 1).toUpperCase();
    }
    return rtVal;
  };

  function getWindowWidth() {
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    // console.log("window width =>", width);
    // console.log("typeof width =>", typeof width);
    return width;
  }

  function setPauseGame(start_date, end_date) {
    var _StartDate = new Date(start_date);
    var _EndDate = new Date(end_date);
    var now = new Date();

    // console.log("start date => ", _StartDate);
    // console.log("end date => ", _EndDate);
    // console.log("now => ", now);

    if (_StartDate < now && now < _EndDate) {
      // Pause
      setPlayPause(true);
    } else {
      setPlayPause(false);
    }
  }

  return (
    <div id="ranking">
      <div className="wrap">
        <input type="checkbox" id="header_btn" />
        <header className="ranking_header">
          <div>
            <Link to="/" className="logo">
              <img src={title_img} alt="" />
            </Link>

            {isPlayPaused ? (
              ""
            ) : (
              <a href="./hanapegiplay" className="play_btn">
                <img src={icon_game_console} alt="" />
              </a>
            )}
          </div>
        </header>

        <content className="ranking_content">
          {/* <!-- point_history.html --> */}
          {/* <input type="checkbox" id="ranking_point_history_btn" />
          <div className="popup" id="ranking_point_history">
            <div className="ranking_point_history_contents">
              <label htmlFor="ranking_point_history_btn" className="close"></label>
              <div className="text">포인트 히스토리 내용</div>
            </div>
            <label htmlFor="ranking_point_history_btn"></label>
          </div> */}

          <img src={ico_crown} alt="" />
          <h3>Rankings </h3>
          <div id="team_points">
            <ul>
              {teampoints.map((item, index) => {
                return item.Teamname.length > 0 && item.Points > 0 ? (
                  <li>
                    <div>
                      <span className="team_points_team">
                        {shortTeamName(item.Teamname)}
                      </span>
                      <span className="team_points_point">
                        {item.Points} Points
                      </span>
                    </div>
                  </li>
                ) : (
                  ""
                );
              })}
            </ul>
          </div>
          <h4>TOP {ranking_limit} Rankings </h4>
          <div id="rankings_div">
            <table>
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Address</th>
                  <th>Team</th>
                  <th>Point</th>
                </tr>
              </thead>

              <tbody>
                {board.length > 0 ? (
                  board.map((item, index) => {
                    return index == 0 ? (
                      <tr key={item.Address} className="rank_1st">
                        <td>&#129351;</td>
                        {item.Discordid.length > 0 ? (
                          <td>{shortId(item.Discordid)}</td>
                        ) : (
                          <td>{shortAddres(item.Address)}</td>
                        )}

                        <td>
                          {item.Teamname.length > 0 ? (
                            <span>{shortTeamName(item.Teamname)}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <label htmlFor="point_history_btn">
                            {item.Totalpoint}
                          </label>
                        </td>
                      </tr>
                    ) : index == 1 ? (
                      <tr key={item.Address} className="rank_2nd">
                        <td>&#129352;</td>
                        {item.Discordid.length > 0 ? (
                          <td>{shortId(item.Discordid)}</td>
                        ) : (
                          <td>{shortAddres(item.Address)}</td>
                        )}
                        <td>
                          {item.Teamname.length > 0 ? (
                            <span>{shortTeamName(item.Teamname)}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <label htmlFor="point_history_btn">
                            {item.Totalpoint}
                          </label>
                        </td>
                      </tr>
                    ) : index == 2 ? (
                      <tr key={item.Address} className="rank_3rd">
                        <td>&#129353;</td>
                        {item.Discordid.length > 0 ? (
                          <td>{shortId(item.Discordid)}</td>
                        ) : (
                          <td>{shortAddres(item.Address)}</td>
                        )}
                        <td>
                          {item.Teamname.length > 0 ? (
                            <span>{shortTeamName(item.Teamname)}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <label htmlFor="point_history_btn">
                            {item.Totalpoint}
                          </label>
                        </td>
                      </tr>
                    ) : (
                      <tr key={item.Address}>
                        <td>{item.Ranking}</td>
                        {item.Discordid.length > 0 ? (
                          <td>{shortId(item.Discordid)}</td>
                        ) : (
                          <td>{shortAddres(item.Address)}</td>
                        )}
                        <td>
                          {item.Teamname.length > 0 ? (
                            <span>{shortTeamName(item.Teamname)}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <label htmlFor="point_history_btn">
                            {item.Totalpoint}
                          </label>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr></tr>
                )}
              </tbody>
            </table>
            {/* <button id="paging" type="button" name="paging">
              More
            </button> */}
          </div>

          <h4>My Ranking</h4>
          {board.length > 0 && myrecord != null ? (
            <div id="my_ranking_wrap">
              <table border="0">
                <tbody>
                  {myrecord.Ranking == 1 ? (
                    <tr id="my_ranking" key={myrecord.Address}>
                      <td>
                        <span className="my_icon">My</span>
                        {myrecord.Ranking}
                      </td>
                      {myrecord.Discordid.length > 0 ? (
                        <td>{shortId(myrecord.Discordid)}</td>
                      ) : (
                        <td>{shortAddres(myrecord.Address)}</td>
                      )}
                      <td>
                        {myrecord.Teamname.length > 0 ? (
                          <span>{shortTeamName(myrecord.Teamname)}</span>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        <label htmlFor="point_history_btn">
                          {myrecord.Totalpoint}
                        </label>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {before_rec !== null && before_rec !== undefined ? (
                        <tr key={before_rec.Address}>
                          <td>{before_rec.Ranking}</td>
                          {before_rec.Discordid.length > 0 ? (
                            <td>{shortId(before_rec.Discordid)}</td>
                          ) : (
                            <td>{shortAddres(before_rec.Address)}</td>
                          )}
                          <td>
                            {before_rec.Teamname.length > 0 ? (
                              <span>{shortTeamName(before_rec.Teamname)}</span>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            <label htmlFor="point_history_btn">
                              {before_rec.Totalpoint}
                            </label>
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}

                      <tr id="my_ranking" key={myrecord.Address}>
                        <td>
                          <span className="my_icon">My</span>
                          {myrecord.Ranking}
                        </td>
                        {myrecord.Discordid.length > 0 ? (
                          <td>{shortId(myrecord.Discordid)}</td>
                        ) : (
                          <td>{shortAddres(myrecord.Address)}</td>
                        )}
                        <td>
                          {myrecord.Teamname.length > 0 ? (
                            <span>{shortTeamName(myrecord.Teamname)}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <label htmlFor="point_history_btn">
                            {myrecord.Totalpoint}
                          </label>
                        </td>
                      </tr>
                      {after_rec !== null && after_rec !== undefined ? (
                        <tr key={after_rec.Address}>
                          <td>{after_rec.Ranking}</td>
                          {after_rec.Discordid.length > 0 ? (
                            <td>{shortId(after_rec.Discordid)}</td>
                          ) : (
                            <td>{shortAddres(after_rec.Address)}</td>
                          )}
                          <td>
                            {after_rec.Teamname.length > 0 ? (
                              <span>{shortTeamName(after_rec.Teamname)}</span>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            <label htmlFor="point_history_btn">
                              {after_rec.Totalpoint}
                            </label>
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            ""
          )}
        </content>
      </div>
    </div>
  );
};
export default Ranking;
